import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  t: "1760234597161",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "2082",
  width: "1em",
  height: "1em"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M717.866667 532.053333a169.258667 169.258667 0 0 1 98.858666 32v-93.866666h-645.930666v292.266666a47.914667 47.914667 0 0 0 46.250666 49.578667h355.413334a184.362667 184.362667 0 0 1-28.885334-99.285333 177.834667 177.834667 0 0 1 174.336-180.565334z",
  fill: "#ffffff",
  "p-id": "2083"
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M717.909333 572.202667a140.8 140.8 0 1 0 135.424 145.962666v-5.376a138.24 138.24 0 0 0-135.424-140.586666z m56.490667 159.573333H717.909333a18.389333 18.389333 0 0 1-18.389333-18.389333v-58.112a18.389333 18.389333 0 1 1 36.736 0v38.4h38.144a18.986667 18.986667 0 0 1 0 37.973333z",
  fill: "#ffffff",
  "p-id": "2084"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M269.781333 170.666667m42.496 0l0 0q42.496 0 42.496 42.496l0 83.285333q0 42.496-42.496 42.496l0 0q-42.496 0-42.496-42.496l0-83.285333q0-42.496 42.496-42.496Z",
  fill: "#ffffff",
  "p-id": "2085"
}, null, -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M778.965333 235.562667a44.842667 44.842667 0 0 0-8.533333-0.298667h-16.085333v61.141333a78.805333 78.805333 0 1 1-157.610667 0v-61.141333h-205.568v61.141333a78.805333 78.805333 0 1 1-157.610667 0v-61.141333h-14.848c-45.226667 0-47.957333 49.450667-47.957333 49.450667v148.906666h645.802667v-148.736a43.861333 43.861333 0 0 0-37.589334-49.322666z",
  fill: "#ffffff",
  "p-id": "2086"
}, null, -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  d: "M632.917333 170.666667m42.496 0l0 0q42.496 0 42.496 42.496l0 83.285333q0 42.496-42.496 42.496l0 0q-42.496 0-42.496-42.496l0-83.285333q0-42.496 42.496-42.496Z",
  fill: "#ffffff",
  "p-id": "2087"
}, null, -1);
const _hoisted_7 = [_hoisted_2, _hoisted_3, _hoisted_4, _hoisted_5, _hoisted_6];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7);
}